// extracted by mini-css-extract-plugin
export default {"list":"PalletsTransferHistoryList_list__x319K","divider":"PalletsTransferHistoryList_divider__NKEhe"};